import { orgScopedApiClient } from 'api/orgScopedClient'
import { Label } from 'types'

import { CerebroPaginatedResponse, CerebroResourceResponse } from '../types'

export const getLabels = (
    params: unknown
): Promise<CerebroPaginatedResponse<Label>> =>
    orgScopedApiClient.get(`/api/labels/`, { params })

export const createLabel = (
    data: unknown
): Promise<CerebroResourceResponse<Label>> =>
    orgScopedApiClient.post(`/api/labels/`, data)

export const getLabel = (
    labelId: string
): Promise<CerebroResourceResponse<Label>> =>
    orgScopedApiClient.get(`/api/label/${labelId}/`)

export const updateLabel = (
    labelId: string,
    data: unknown
): Promise<CerebroResourceResponse<Label>> =>
    orgScopedApiClient.patch(`/api/label/${labelId}/`, data)

export const deleteLabel = (
    labelId: string
): Promise<CerebroResourceResponse<void>> =>
    orgScopedApiClient.delete(`/api/label/${labelId}/`)
